export const heroTexts = {
  Herottitle: {
      ko: (
        <>
          귀사의 귀중한 IT 자산은... 
          <br />세계적 수준의 보안 솔루션으로 철저한 보호
        </>
      ),
      en: (
        <>
          Your valuable IT assets are perfectly protected by world-class security solutions.
        </>
      )
  },
  Heromessage: {
      ko: (
        <>
          (주)리마 : 세계적으로 검증된 보안 솔루션을 발굴하는 회사
        </>
      ),
      en: (
        <>
          Global leader in security solutions
        </>
      )
  }
};

export const ConactTexts = {
  Contacttitle: {
      ko: (
        <>
          당연히 궁금한 점이 있으시지요?
        </>
      ),
      en: (
        <>
          Do you have any questions?
        </>
      )
  },
  Contactmessage: {
      ko: (
        <>
          제품 기능, 구매, 견적 등에 대한 상세한 문의는 신속히 답변드리겠습니다.
        </>
      ),
      en: (
        <>
          For detailed inquiries about product features, purchases, quotes, etc., we will respond promptly.
        </>
      )
  },
    Contactbtn: {
      ko: (
        <>
          문의하기
        </>
      ),
      en: (
        <>
          Contact Us
        </>
      )
  }
}

export const ChallengeTexts = {
  title: {
      ko: (
        <>
          솔루션 목표
        </>
      ),
      en: (
        <>
          Solution Challenge
        </>
      )
  },
  message: {
      ko: (
        <>
          모든 솔루션은 보안성 및 사용성이 높은 제품을 목표로 합니다.
        </>
      ),
      en: (
        <>
          All solutions aim for high security and usability.
        </>
      )
  },
  Security: {
    ko: (
      <>
        보안성
      </>
    ),
    en: (
      <>
        Security
      </>
    )
  },
  Usability: {
    ko: (
      <>
        사용성
      </>
    ),
    en: (
      <>
        Usability
      </>
    )
  },
  obstacle: {
    ko: (
      <>
        장애
      </>
    ),
    en: (
      <>
        Obstacle
      </>
    )
  }
}